export const minutesAndSecondsElapsed = ({ since }) => {
  const diff = Date.now() - since;

  const minutes = Math.floor(diff / (60 * 1000));
  const seconds = (diff / 1000) % 60;

  return `${minutes.toFixed(0).padStart(2, "0")}:${seconds.toFixed(0).padStart(2, "0")}`;
};
